import styles from './PwaUpdateLayer.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import usePwaUpdateStore from '../stores/pwaUpdate'
import useTranslation from '../Hooks/useTranslation'
import { applyUpdateAndReload, buildLabel } from '../libs/pwaUpdate'

/**
 * messika-pwa#34 : overlay bloquant de mise à jour, message d'incompatibilité de la base locale
 * (Dexie VersionError) et bandeau « Nouvelle version disponible » en cours de session.
 */
function PwaUpdateLayer() {
   const { trans } = useTranslation()
   const updating = usePwaUpdateStore((s) => s.updating)
   const updateAvailable = usePwaUpdateStore((s) => s.updateAvailable)
   const dbIncompatible = usePwaUpdateStore((s) => s.dbIncompatible)

   if (dbIncompatible) {
      return (
         <div className={styles.background}>
            <div className={styles.popup}>
               <div>{trans('?pwa_db_incompatible')}</div>
               <div className={styles.detail}>{buildLabel()}</div>
            </div>
         </div>
      )
   }
   if (updating) {
      return (
         <div className={styles.background}>
            <div className={styles.popup}>
               <div className={styles.title}>
                  <FontAwesomeIcon icon={faSpinner} spin />
                  <span>{trans('?pwa_updating')}</span>
               </div>
            </div>
         </div>
      )
   }
   if (updateAvailable) {
      return (
         <div className={styles.banner}>
            <span>{trans('?pwa_new_version')}</span>
            <button onClick={() => { void applyUpdateAndReload(true) }}>{trans('?pwa_reload')}</button>
         </div>
      )
   }
   return null
}

export default PwaUpdateLayer
